import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'medias',
    props: true,
    meta: {
      middleware: [loggedIn]
    },
    component: () => import(/* webpackChunkName: "medias" */ './page.vue'),
    children: [
      {
        path: ':id',
        name: 'mediasTableComponent',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "appTableComponent" */ './item/index.vue'
          ),
        meta: {
          rootRouteName: 'medias'
        }
      },
      {
        path: ':id/:nestedId',
        name: 'mediasNestedComponent',
        props: true,
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'medias' }
  }
];
